import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//internal import
import ClientService from "../services/ClientService";
import { allContext } from "../context/AllContext";
import { notifySuccess, notifyError } from "../utils/toast";

const useClientSubmit = (id) => {

    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();

    const { pageLoading, setPageLoading, dataUpdate, setDataUpdate } = useContext(allContext);

    const [imageUrl, setImageUrl] = useState("");
    const [isModal, setIsModal] = useState(false);
    const [isViewModal, setIsViewModal] = useState(false);
    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [projectsArr, setProjectsArr] = useState([]);
    const [viewData, setviewData] = useState([]);


    // add and update client details
    const onSubmit = async (data) => {

        setPageLoading(true);  
        try {
            data.profileImage = imageUrl;
            data.projects = projectsArr;

            const response = id ? await ClientService.UpdateClientById(id, data) : await ClientService.addClient(data);
            if (response?.success) {
                notifySuccess(response.message);
                setIsModal(false);
                setDataUpdate(!dataUpdate);
            }
            else {
                notifyError(response.message);
            }
        } catch (error) {
            console.error(error);
            notifyError(error?.response?.data?.message || error.message);
        } finally {
            setPageLoading(false);
        }
    };

    //  delete client by id 
    const handleDeleteClient = async (id) => {
        try {
            const response = await ClientService.deleteClientById(id);
            if (response.success) {
                notifySuccess(response?.message);
                setDataUpdate(!dataUpdate);
            }
            else {
                notifyError(response?.message);
            }
            setIsDeleteModal(false);
        }
        catch (error) {
            console.error("error", error);
            notifyError("Something want wrong !");
            setIsDeleteModal(false);
        }
    }

    useEffect(() => {
        reset();
        setProjectsArr([]); 
        if (id) {
            (async () => {
                try {
                    const res = await ClientService.getClientById(id);
                    const data = res?.client;
                    if (res?.success) {
                        setviewData(data);
                        setValue("username", data.username);
                        setValue("emailId", data.emailId);
                        setValue("clientName", data.clientName);
                        setValue("companyName", data.companyName);
                        setValue("clientCode", data.clientCode);
                        // setValue("password", data.password);
                        setValue("phone", data.phone);
                        setValue("description", data.description);
                        setValue("contactPerson", data.contactPerson);
                        setValue("status", data.status);
                        setImageUrl(data?.profileImage || "");
                        setProjectsArr(data?.projects || []);              
                    }
                } catch (error) {
                    console.error("Error fetching client data:", error);
                }
            })();
        }
    }, [isModal, id]);

    return {
        register,
        handleSubmit,
        setValue,
        errors,
        onSubmit,
        handleDeleteClient,
        pageLoading,
        imageUrl,
        setImageUrl,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        viewData,
        projectsArr,
        setProjectsArr
    }
}

export default useClientSubmit;